import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Hero = ({ propiedad, ruta, config }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const heroImages = propiedad.fotos_web;

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % heroImages.length);
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    const { t } = useTranslation();

    return (
        <div className="cc-swiper-hero">
            <div init="false" pagination="true" navigation="false" className="c-swiper-hero">
                {heroImages.map((image, index) => (
                    <div className={`${index === currentSlide ? 'opacity-100' : 'opacity-0'
                        }`} role="group" aria-label="2 / 3" data-swiper-slide-index="1" key={index}>
                        <img
                            src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + image.nombre}
                            alt={`${propiedad.nombre} - Slide ${index + 1}`}
                        />
                    </div>
                )
                )}
            </div>
        </div>
    );
};

export default Hero;
